import React, { useEffect, useRef } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './tire-tread-manufacturer.reducer';

export const TireTreadManufacturerDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const hasDeleted = useRef(false);

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const tireTreadManufacturerEntity = useAppSelector(state => state.tireTreadManufacturer.entity);
  const updateSuccess = useAppSelector(state => state.tireTreadManufacturer.updateSuccess);

  const handleClose = () => {
    props.history.push('/tire-tread-manufacturer' + props.location.search);
  };

  useEffect(() => {
    if (updateSuccess && hasDeleted.current) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    hasDeleted.current = true;
    dispatch(deleteEntity(tireTreadManufacturerEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="tireTreadManufacturerDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="fleetSenseApp.tireTreadManufacturer.delete.question">
        <Translate contentKey="fleetSenseApp.tireTreadManufacturer.delete.question" interpolate={{ id: tireTreadManufacturerEntity.name }}>
          Are you sure you want to delete this TireTreadManufacturer?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="app-confirm-delete-tireTreadManufacturer" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TireTreadManufacturerDeleteDialog;
